<div class="sub-nav" *ngIf="items.length">
  <div class="sub-nav__inner">
    <a
      *ngFor="let item of items"
      [routerLink]="item.route"
      routerLinkActive="sub-nav__link--active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="sub-nav__link"
    >
      {{ item.label | translate }}
    </a>
  </div>
</div>
